var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("div", {
    staticClass: "app-container"
  }, [_c("el-backtop", {
    attrs: {
      bottom: 100
    }
  }, [_c("div", {
    staticStyle: {
      height: "100%",
      width: "100%",
      "background-color": "var(--el-bg-color-overlay)",
      "box-shadow": "var(--el-box-shadow-lighter)",
      "text-align": "center",
      "line-height": "40px",
      color: "#1989fa",
      display: "flex",
      "align-items": "center",
      "justify-content": "center",
      "border-radius": "50%"
    }
  }, [_c("i", {
    staticClass: "el-icon-arrow-up",
    staticStyle: {
      "font-size": "20px"
    }
  })])]), _c("div", {
    staticClass: "filter-header",
    staticStyle: {
      display: "flex",
      "justify-content": "space-between",
      "margin-bottom": "10px"
    }
  }, [_c("el-button", {
    attrs: {
      type: "primary",
      size: "mini"
    },
    on: {
      click: function ($event) {
        _vm.showFilters = !_vm.showFilters;
      }
    }
  }, [_vm._v(" Filters & More "), _c("i", {
    class: _vm.showFilters ? "el-icon-arrow-up" : "el-icon-arrow-down",
    staticStyle: {
      "margin-left": "5px"
    }
  })])], 1), _vm.showFilters ? _c("div", {
    staticClass: "filter-container"
  }, [_c("VueCtkDateTimePicker", {
    staticClass: "filter-item",
    attrs: {
      range: "",
      formatted: "DD-MM-YYYY",
      "custom-shortcuts": _vm.shortcuts
    },
    model: {
      value: _vm.dateRange,
      callback: function ($$v) {
        _vm.dateRange = $$v;
      },
      expression: "dateRange"
    }
  }), _c("el-select", {
    attrs: {
      filterable: "",
      clearable: "",
      name: "branchId",
      placeholder: "Select Branch"
    },
    on: {
      change: _vm.handleFilter
    },
    model: {
      value: _vm.listQuery.branchId,
      callback: function ($$v) {
        _vm.$set(_vm.listQuery, "branchId", $$v);
      },
      expression: "listQuery.branchId"
    }
  }, _vm._l(_vm.branchList, function (branch) {
    return _c("el-option", {
      key: branch.id,
      attrs: {
        label: branch.code,
        value: branch.id
      }
    });
  }), 1), !_vm.isSalesExecutiveAdmin() ? _c("el-select", {
    staticClass: "filter-item",
    attrs: {
      filterable: "",
      clearable: "",
      placeholder: "Select Branch Manager"
    },
    on: {
      change: _vm.handleFilter
    },
    model: {
      value: _vm.listQuery["mappedAdmin.id"],
      callback: function ($$v) {
        _vm.$set(_vm.listQuery, "mappedAdmin.id", $$v);
      },
      expression: "listQuery['mappedAdmin.id']"
    }
  }, _vm._l(_vm.salesExecutiveAdmins, function (salesExecutive) {
    return _c("el-option", {
      key: salesExecutive.id,
      attrs: {
        label: salesExecutive.fullName,
        value: salesExecutive.id
      }
    });
  }), 1) : _vm._e(), !_vm.isZonalManagerAdmin() ? _c("el-select", {
    staticClass: "filter-item",
    attrs: {
      filterable: "",
      clearable: "",
      placeholder: "Select Zonal Manager"
    },
    on: {
      change: _vm.handleFilter
    },
    model: {
      value: _vm.listQuery["zonalAdmin.id"],
      callback: function ($$v) {
        _vm.$set(_vm.listQuery, "zonalAdmin.id", $$v);
      },
      expression: "listQuery['zonalAdmin.id']"
    }
  }, _vm._l(_vm.zonalManagerAdmins, function (zonalAdmin) {
    return _c("el-option", {
      key: zonalAdmin.id,
      attrs: {
        label: zonalAdmin.fullName,
        value: zonalAdmin.id
      }
    });
  }), 1) : _vm._e(), !_vm.isAgent ? _c("el-select", {
    staticClass: "filter-item",
    attrs: {
      filterable: "",
      clearable: "",
      placeholder: _vm.$t("dealersDispatch.agent")
    },
    on: {
      change: _vm.handleFilter
    },
    model: {
      value: _vm.listQuery.agentId,
      callback: function ($$v) {
        _vm.$set(_vm.listQuery, "agentId", $$v);
      },
      expression: "listQuery.agentId"
    }
  }, _vm._l(_vm.agentList, function (agent) {
    return _c("el-option", {
      key: agent.id,
      attrs: {
        label: agent.name,
        value: agent.id
      }
    });
  }), 1) : _vm._e(), !_vm.isAgent ? _c("el-select", {
    staticClass: "filter-item",
    attrs: {
      disabled: !_vm.listQuery.agentId,
      filterable: "",
      clearable: "",
      placeholder: "Select Sales Executive Agent"
    },
    on: {
      change: _vm.handleFilter
    },
    model: {
      value: _vm.listQuery["assignedAgents.id"],
      callback: function ($$v) {
        _vm.$set(_vm.listQuery, "assignedAgents.id", $$v);
      },
      expression: "listQuery['assignedAgents.id']"
    }
  }, _vm._l(_vm.agentUserList, function (agentUser) {
    return _c("el-option", {
      key: agentUser.id,
      attrs: {
        label: agentUser.fullName,
        value: agentUser.id
      }
    });
  }), 1) : _vm._e(), _c("el-select", {
    staticClass: "filter-item",
    attrs: {
      filterable: "",
      clearable: "",
      remote: "",
      loading: _vm.dealerListLoading,
      "loading-text": "fetching dealers..",
      "remote-method": _vm.getDealerList,
      placeholder: _vm.$t("dealersDispatch.dealer")
    },
    on: {
      change: _vm.handleFilter
    },
    model: {
      value: _vm.listQuery.dealerId,
      callback: function ($$v) {
        _vm.$set(_vm.listQuery, "dealerId", $$v);
      },
      expression: "listQuery.dealerId"
    }
  }, _vm._l(_vm.dealerList, function (dealer) {
    return _c("el-option", {
      key: dealer.id,
      attrs: {
        label: dealer.name,
        value: dealer.id
      }
    }, [_c("span", {
      staticStyle: {
        float: "left",
        "font-size": "13px"
      }
    }, [_vm._v(_vm._s(dealer.name) + " - " + _vm._s(dealer.code))]), _c("span", {
      staticStyle: {
        float: "right",
        color: "#8492a6",
        "font-size": "13px"
      }
    }, [_vm._v("   | ID: " + _vm._s(dealer.id))])]);
  }), 1), _c("el-select", {
    staticClass: "filter-item",
    attrs: {
      filterable: "",
      clearable: "",
      placeholder: "States"
    },
    on: {
      change: _vm.handleFilter
    },
    model: {
      value: _vm.listQuery.stateId,
      callback: function ($$v) {
        _vm.$set(_vm.listQuery, "stateId", $$v);
      },
      expression: "listQuery.stateId"
    }
  }, _vm._l(_vm.stateList, function (state) {
    return _c("el-option", {
      key: state.id,
      attrs: {
        label: state.name,
        value: state.id
      }
    }, [_c("span", {
      staticStyle: {
        float: "left",
        "font-size": "13px"
      }
    }, [_vm._v(_vm._s(state.name))])]);
  }), 1), _c("el-select", {
    staticClass: "filter-item",
    attrs: {
      disabled: !_vm.listQuery.stateId > 0,
      clearable: "",
      filterable: "",
      placeholder: "Cities"
    },
    on: {
      change: _vm.handleFilter
    },
    model: {
      value: _vm.listQuery.cityId,
      callback: function ($$v) {
        _vm.$set(_vm.listQuery, "cityId", $$v);
      },
      expression: "listQuery.cityId"
    }
  }, _vm._l(_vm.cityList, function (city) {
    return _c("el-option", {
      key: city.id,
      attrs: {
        label: city.name,
        value: city.id
      }
    });
  }), 1), _c("el-button", {
    directives: [{
      name: "waves",
      rawName: "v-waves"
    }],
    staticClass: "filter-item",
    attrs: {
      type: "primary",
      icon: "el-icon-search",
      size: "mini"
    },
    on: {
      click: _vm.handleFilter
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("table.search")) + " ")]), _c("el-button", {
    directives: [{
      name: "waves",
      rawName: "v-waves"
    }],
    staticClass: "filter-item",
    attrs: {
      type: "primary",
      size: "mini",
      icon: "el-icon-document"
    },
    on: {
      click: _vm.handleExcelDownload
    }
  }, [_vm._v(" Export as Excel ")]), _c("el-select", {
    attrs: {
      multiple: "",
      "collapse-tags": "",
      placeholder: "Select Additional Columns"
    },
    on: {
      change: _vm.handleVisibleColumns
    },
    model: {
      value: _vm.selectedColumns,
      callback: function ($$v) {
        _vm.selectedColumns = $$v;
      },
      expression: "selectedColumns"
    }
  }, _vm._l(_vm.columnOptions, function (item) {
    return _c("el-option", {
      key: item.key,
      attrs: {
        label: item.label,
        value: item.key
      }
    });
  }), 1)], 1) : _vm._e(), _vm._isAdminRoles() ? _c("el-checkbox", {
    on: {
      change: _vm.onCheckboxChange
    },
    model: {
      value: _vm.listQuery.excludeBranches,
      callback: function ($$v) {
        _vm.$set(_vm.listQuery, "excludeBranches", $$v);
      },
      expression: "listQuery.excludeBranches"
    }
  }, [_vm._v(" Uncheck to include branch ")]) : _vm._e(), _vm.dateRange ? _c("div", {
    staticStyle: {
      display: "flex",
      "align-items": "center",
      "flex-wrap": "wrap",
      gap: "16px",
      "margin-bottom": "10px"
    }
  }, [_c("div", {
    staticStyle: {
      display: "flex",
      "align-items": "center",
      gap: "6px",
      "flex-shrink": "0"
    }
  }, [_c("span", {
    staticStyle: {
      "font-size": "13px",
      "font-weight": "600",
      color: "#606266"
    }
  }, [_vm._v("Selected date:")]), _c("el-tag", {
    attrs: {
      type: "warning"
    }
  }, [_vm._v(" " + _vm._s(_vm._f("moment")(_vm.dateRange.start, "DD-MM-YYYY hh:mm")) + " ")]), _c("span", {
    staticStyle: {
      color: "#606266"
    }
  }, [_vm._v("-")]), _c("el-tag", {
    attrs: {
      type: "warning"
    }
  }, [_vm._v(" " + _vm._s(_vm._f("moment")(_vm.dateRange.end, "DD-MM-YYYY hh:mm")) + " ")])], 1), _c("div", {
    staticStyle: {
      border: "0.5px solid #e4e7ed",
      "border-radius": "8px",
      padding: "5px 12px",
      display: "flex",
      "align-items": "center",
      gap: "10px",
      background: "#fafafa"
    }
  }, [_c("span", {
    staticStyle: {
      "font-size": "12px",
      "font-weight": "700",
      color: "#303133",
      "letter-spacing": "0.03em"
    }
  }, [_vm._v("PAYMENTS")]), _c("div", {
    staticStyle: {
      width: "1px",
      height: "20px",
      background: "#e4e7ed"
    }
  }), _c("div", {
    staticStyle: {
      display: "flex",
      "align-items": "center",
      gap: "4px"
    }
  }, [_c("span", {
    staticStyle: {
      "font-size": "12px",
      "font-weight": "600",
      color: "#606266"
    }
  }, [_vm._v("Page:")]), _c("el-tag", {
    attrs: {
      type: "primary",
      size: "mini"
    }
  }, [_c("inr", {
    attrs: {
      number: Number(_vm.pageTotalPayments)
    }
  })], 1)], 1), _c("div", {
    staticStyle: {
      display: "flex",
      "align-items": "center",
      gap: "4px"
    }
  }, [_c("span", {
    staticStyle: {
      "font-size": "12px",
      "font-weight": "600",
      color: "#606266"
    }
  }, [_vm._v("Grand:")]), _c("el-tag", {
    attrs: {
      type: "success",
      size: "mini"
    }
  }, [_c("inr", {
    attrs: {
      number: Number(_vm.totalGrandTotal)
    }
  })], 1)], 1)])]) : _vm._e(), _c("el-table", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.listLoading,
      expression: "listLoading"
    }],
    key: _vm.tableKey,
    staticStyle: {
      width: "100%"
    },
    attrs: {
      data: _vm.list,
      border: "",
      fit: "",
      "highlight-current-row": ""
    },
    on: {
      "sort-change": _vm.sortChange
    }
  }, [_vm.showId ? _c("el-table-column", {
    attrs: {
      width: "80",
      align: "center",
      label: "ID",
      prop: "dealer_id",
      sortable: "custom"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_vm._v(" " + _vm._s(scope.row.dealer_id) + " ")];
      }
    }], null, false, 984237940)
  }) : _vm._e(), _vm.showDealerCode ? _c("el-table-column", {
    attrs: {
      width: "175",
      align: "center",
      prop: "dealer_code",
      label: "Dealer Code",
      sortable: "custom"
    }
  }) : _vm._e(), _c("el-table-column", {
    attrs: {
      width: "325",
      prop: "dealer_name",
      label: "Dealer Name",
      sortable: "custom"
    }
  }), _vm.showDealerCity ? _c("el-table-column", {
    attrs: {
      width: "125",
      align: "center",
      prop: "dealer_city",
      label: "City",
      sortable: "custom"
    }
  }) : _vm._e(), _vm.showDealerState ? _c("el-table-column", {
    attrs: {
      width: "125",
      align: "center",
      prop: "state_name",
      label: "State",
      sortable: "custom"
    }
  }) : _vm._e(), _c("el-table-column", {
    attrs: {
      width: "200",
      align: "center",
      prop: "agent_name",
      label: "Agent",
      sortable: "custom"
    }
  }), _vm.showSalesExecutiveAgent ? _c("el-table-column", {
    attrs: {
      width: "200",
      align: "center",
      prop: "assignedAgent_fullName",
      label: "Sales Executive Agent",
      sortable: "custom"
    }
  }) : _vm._e(), _vm.showBranchManagerAdmin ? _c("el-table-column", {
    attrs: {
      width: "200",
      align: "center",
      label: "Branch Manager",
      sortable: "custom"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function ({
        row
      }) {
        return [_vm._v(" " + _vm._s(_vm.getAdminByRole(row.mappedAdmins, "Branch Manager")) + " ")];
      }
    }], null, false, 3820433298)
  }) : _vm._e(), _vm.showZonalManager ? _c("el-table-column", {
    attrs: {
      width: "200",
      align: "center",
      label: "Zonal Manager",
      sortable: "custom"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function ({
        row
      }) {
        return [_vm._v(" " + _vm._s(_vm.getAdminByRole(row.mappedAdmins, "Zonal Manager")) + " ")];
      }
    }], null, false, 1504708304)
  }) : _vm._e(), _c("el-table-column", {
    attrs: {
      width: "180",
      align: "left",
      label: "Payment",
      prop: "totalAmount",
      sortable: "custom"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("inr", {
          attrs: {
            number: scope.row.totalAmount
          }
        })];
      }
    }])
  })], 1), _c("pagination", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.total > 0,
      expression: "total > 0"
    }],
    attrs: {
      total: _vm.total,
      page: _vm.listQuery.page,
      limit: _vm.listQuery.limit
    },
    on: {
      "update:page": function ($event) {
        return _vm.$set(_vm.listQuery, "page", $event);
      },
      "update:limit": function ($event) {
        return _vm.$set(_vm.listQuery, "limit", $event);
      },
      pagination: _vm.getList
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };